import { render, staticRenderFns } from "./DPDraftList.vue?vue&type=template&id=fb6d3752&scoped=true&"
import script from "./DPDraftList.vue?vue&type=script&lang=js&"
export * from "./DPDraftList.vue?vue&type=script&lang=js&"
import style0 from "./DPDraftList.vue?vue&type=style&index=0&id=fb6d3752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6d3752",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb6d3752')) {
      api.createRecord('fb6d3752', component.options)
    } else {
      api.reload('fb6d3752', component.options)
    }
    module.hot.accept("./DPDraftList.vue?vue&type=template&id=fb6d3752&scoped=true&", function () {
      api.rerender('fb6d3752', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/services/directPayments/DPDraftList.vue"
export default component.exports